import { nullable, number, optional, picklist, pipe, type InferOutput } from "valibot"
import { EntityHeadingDeg } from "./consts"

export const EntityHeadingSchema = pipe(number(), picklist([
  EntityHeadingDeg.North, // 0
  EntityHeadingDeg.East, // 90
  EntityHeadingDeg.South, // 180
  EntityHeadingDeg.West, // 270
], "Invalid heading"))

export type EntityHeading = InferOutput<typeof EntityHeadingSchema>

export const NullableEntityHeadingSchema = nullable(EntityHeadingSchema)

export type NullableEntityHeading = InferOutput<typeof NullableEntityHeadingSchema>

export const OptionalNullableEntityHeadingSchema = optional(NullableEntityHeadingSchema)

export type OptionalNullableEntityHeading = InferOutput<typeof OptionalNullableEntityHeadingSchema>